<div class="admin-modal">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">
      {{ title }}
    </h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimise = !minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Body -->
  <div class="modal-body" [hidden]="minimise">
    <form #actionForm="ngForm" novalidate>

      @if (loading) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>
}

      <!-- Row 1: Action Key, Name, Description, Active, Version -->
      @if (!loading) {
<div class="row">
        @if (mode === 'edit') {
<div class="col-md-1">
          <label class="label-nowrap">Action Key:</label>
          <div class="btn btn-default read-only-field">{{ action_data.action_key }}</div>
        </div>
}

        <div class="col-md-2">
          <label>Action Name:</label>
          <input type="text" class="form-control" name="action_name" required
                 #actionNameCtrl="ngModel"
                 placeholder="enter action name"
                 [(ngModel)]="action_data.action_name" />
          @if (actionNameCtrl.invalid && (actionNameCtrl.touched || submitted)) {
<span class="form-error-container"
               >Action Name is required.</span>
}
        </div>

        <div class="col-md-3">
          <label>Action Description:</label>
          <textarea class="form-control input-sm"
                    [(ngModel)]="action_data.action_desc" name="action_desc"></textarea>
        </div>

        @if (mode === 'edit') {
<div class="col-md-1">
          <label>Active:</label>
          <div>
            <input type="checkbox"
                   [ngModel]="action_data.active == 1"
                   (ngModelChange)="action_data.active = $event ? 1 : 0"
                   name="active" />
          </div>
        </div>
}

        @if (mode === 'edit') {
<div class="col-md-1">
          <label>Version:</label>
          <div class="btn btn-default read-only-field">{{ action_data.action_version_num }}</div>
        </div>
}

        @if (action_data.max_version_num > 1) {
<div class="col-md-1">
          <label>Versions</label>
          <div class="btn btn-default read-only-field">{{ action_data.min_version_num }} - {{ action_data.max_version_num }}</div>
        </div>
}

        @if (action_data.max_version_num > 1) {
<div class="col-md-3">
          <label>Versions</label><br/>
          @if (canGoPrevious) {
<div class="btn btn-default btn-sm"
               (click)="updateVersion(action_data.action_version_num - 1)">
            <i class="fa fa-chevron-circle-left"></i> Previous
          </div>
}
          @if (canGoNext) {
<div class="btn btn-default btn-sm"
               (click)="updateVersion(action_data.action_version_num + 1)">
            <i class="fa fa-chevron-circle-right"></i> Next
          </div>
}
        </div>
}
      </div>
}

      <!-- Row 2: Permission Level, Core Action, JCD Required, Response Setting, Action Check -->
      @if (!loading) {
<div class="row row-spaced">
        <div class="col-md-2">
          <label class="label-nowrap">Permission Level: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="User permission level required to execute this action" direction="top"></i></label>
          <select class="form-control" name="permission"
                  #permissionCtrl="ngModel"
                  [(ngModel)]="permissionSelected"
                  [compareWith]="compareByValue"
                  (ngModelChange)="onPermissionChange()" required>
            <option [ngValue]="null" disabled>-- Select --</option>
            @for (p of permissionList; track $index) {
<option [ngValue]="p">{{ p.name }}</option>
}
          </select>
        </div>

        <div class="col-md-2">
          <label class="label-nowrap">Core Action <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="System core action - cannot be overridden by client" direction="top"></i></label>
          <div>
            <input type="checkbox"
                   [ngModel]="action_data.system_core == 1"
                   (ngModelChange)="action_data.system_core = $event ? 1 : 0; onSystemCoreChange()"
                   name="system_core" />
          </div>
        </div>

        <div class="col-md-2">
          <label class="label-nowrap">JCD Required: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Jurisdiction/Channel/Domain mapping required for this action" direction="top"></i></label>
          <div>
            <input type="checkbox"
                   [ngModel]="jcd_required == 1"
                   (ngModelChange)="jcd_required = $event ? 1 : 0"
                   name="jcd_required" />
          </div>
        </div>

        <div class="col-md-3">
          <label class="label-nowrap">Response Setting: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="JSON object defining response configuration for this action" direction="top"></i></label>
          <textarea class="form-control" placeholder="Enter JSON Object..."
                    [(ngModel)]="action_data.response_settings" name="response_setting"
                    (ngModelChange)="updateJsonValidity()"></textarea>
          @if (isJsonValid === true || isJsonValid === undefined) {
<b style="color: green">Valid Json</b>
}
          @if (isJsonValid === false) {
<b style="color: red">Invalid Json</b>
}
        </div>

        <div class="col-md-2">
          <label>Action Check</label>
          <select class="form-control" name="actionCheck"
                  [(ngModel)]="action_check_type"
                  (ngModelChange)="onActionCheckChange()">
            <option value=""></option>
            @for (ac of actionCheckList; track $index) {
<option [value]="ac.value">{{ ac.name }}</option>
}
          </select>
          <span style="font-style: italic; font-size: 12px;">Please change to admin, if the action is admin</span>
        </div>
      </div>
}

      <!-- JCD Section (shown when jcd_required is checked) -->
      @if (!loading && jcd_required == 1 && jcdlist?.channel && jcdlist?.task && jcdlist?.activity) {
<div class="row row-spaced row-gray-callout">
        <div class="row" style="margin: 10px 5px 0px 5px;">

          <div class="col-md-2">
            <label class="label-nowrap">Channel: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select communication channel" direction="top"></i></label>
            <select class="form-control" name="channel" required
                    #channelCtrl="ngModel"
                    [(ngModel)]="jcdlist.channel.selected"
                    (ngModelChange)="onJcdSelectChange(3)">
              <option [ngValue]="null"></option>
              @for (s of jcdlist.channel?.list; track $index) {
<option [ngValue]="s">{{ s.name }}</option>
}
            </select>
            @if (channelCtrl.invalid && (channelCtrl.touched || submitted)) {
<span class="form-error-container"
                 >Channel is required.</span>
}
          </div>

          <div class="col-md-2">
            <label class="label-nowrap">Task: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select applicable task" direction="top"></i></label>
            <select class="form-control" name="task" required
                    #taskCtrl="ngModel"
                    [disabled]="jcdlist.task?.disabled"
                    [(ngModel)]="jcdlist.task.selected"
                    (ngModelChange)="onJcdSelectChange(4)">
              <option [ngValue]="null"></option>
              @for (s of jcdlist.task?.taskList; track $index) {
<option [ngValue]="s.task_key">{{ s.indent }}{{ s.task_name }}</option>
}
            </select>
            @if (taskCtrl.invalid && (taskCtrl.touched || submitted)) {
<span class="form-error-container"
                 >Task is required.</span>
}
          </div>

          <div class="col-md-2">
            <label class="label-nowrap">Activity: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select applicable activity" direction="top"></i></label>
            <select class="form-control" name="activity" required
                    #activityCtrl="ngModel"
                    [disabled]="jcdlist.activity?.disabled"
                    [(ngModel)]="jcdlist.activity.selected"
                    (ngModelChange)="onJcdSelectChange(5)">
              <option [ngValue]="null"></option>
              @for (s of jcdlist.activity?.list; track $index) {
<option [ngValue]="s">{{ s.name }}</option>
}
            </select>
            @if (activityCtrl.invalid && (activityCtrl.touched || submitted)) {
<span class="form-error-container"
                 >Activity is required.</span>
}
          </div>

          @if (action_data.jcd_ta_key) {
<div class="col-md-1">
            <div style="margin-top: 24px; background-color: #FFFFFF; color: #37d631;" class="btn btn-default">
              <i class="fa fa-check"></i> {{ action_data.jcd_ta_key }}
            </div>
          </div>
}

          <div class="col-md-2">
            <label class="label-nowrap">Action Role: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Role assigned to this action within the JCD mapping" direction="top"></i></label>
            @if (roles.loading) {
<div><i class="fa fa-spinner fa-spin"></i></div>
}
            @if (!roles.loading) {

              <select class="form-control" name="roles" required
                      #rolesCtrl="ngModel"
                      [disabled]="roles.disabled"
                      [(ngModel)]="roles.selected">
                <option [ngValue]="null"></option>
                @for (r of roles.list; track $index) {
<option [ngValue]="r">{{ r.role_name }}</option>
}
              </select>
              @if (rolesCtrl.invalid && (rolesCtrl.touched || submitted)) {
<span class="form-error-container"
                   >Action Role is required.</span>
}
            
}
          </div>

        </div>
      </div>
}

      <!-- Row 3: Action Type, Datasource, Override, Fetch Size, Cache Results -->
      @if (!loading) {
<div class="row row-spaced">
        <div class="col-md-2">
          <label class="label-nowrap">Action Type: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Type of action: grid, update, delete, static, etc." direction="top"></i></label>
          <select class="form-control" name="action_type" required
                  #actionTypeCtrl="ngModel"
                  [(ngModel)]="actionTypeSelected"
                  [compareWith]="compareByValue"
                  (ngModelChange)="onActionTypeChange()">
            @for (t of actionTypeList; track $index) {
<option [ngValue]="t">{{ t.name }}</option>
}
          </select>
        </div>

        <div class="col-sm-2">
          <label class="label-nowrap">Datasource <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Database datasource used by this action" direction="top"></i></label>
          @if (action_data.override !== 1) {
<div>
            <b>{{ action_data.datasource_id }}</b>
          </div>
}
          @if (action_data.override === 1) {
<div>
            <select class="form-control" name="datasource"
                    [(ngModel)]="datasourceSelected"
                    (ngModelChange)="onDatasourceChange()">
              @for (ds of datasourceList; track $index) {
<option [ngValue]="ds">{{ ds.datasource_name }}</option>
}
            </select>
          </div>
}
        </div>

        @if (action_data.system_core != 1) {
<div class="col-sm-1">
          <label class="label-nowrap">Override <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Override the default datasource for this action" direction="top"></i></label>
          <div>
            <input type="checkbox"
                   [ngModel]="action_data.override == 1"
                   (ngModelChange)="action_data.override = $event ? 1 : 0; onOverrideChange()"
                   name="override_required" />
          </div>
        </div>
}

        <div class="col-md-2">
          <label>Fetch Size:</label>
          <input type="number" class="form-control" name="action_fetch_size" required
                 #fetchSizeCtrl="ngModel"
                 [(ngModel)]="action_data.action_fetch_size" />
          @if (fetchSizeCtrl.invalid && (fetchSizeCtrl.touched || submitted)) {
<span class="form-error-container"
               >Fetch Size is required.</span>
}
        </div>

        <div class="col-md-2">
          <label>Cache Results</label><br/>
          <label>
            <input type="radio" name="use_cache" value="Y"
                   [(ngModel)]="action_data.use_cache" /> Yes
          </label><br/>
          <label>
            <input type="radio" name="use_cache" value="N"
                   [(ngModel)]="action_data.use_cache" /> No
          </label>
        </div>
      </div>
}

      <!-- Row 4: Validation Rules (only for grid/update/delete) -->
      @if (!loading && (action_data.action_type === 'grid' || action_data.action_type === 'update' || action_data.action_type === 'delete')) {
<div class="row row-spaced">
        <div class="col-md-4">
          <label>Select Applicable Validation Rule:</label>
          <select class="form-control" name="validation_rules"
                  [(ngModel)]="selectedDroolsRuleObj"
                  (ngModelChange)="onValidationRuleChange()">
            <option [ngValue]="{}"></option>
            @for (rule of validationRulesList; track $index) {
<option [ngValue]="rule">{{ rule.validation_name }}</option>
}
          </select>
        </div>
        <div class="col-md-3">
          <label>Validation Rules Description</label>
          @if (selectedDroolsRuleObj?.validation_key > 0) {
<label>
            [ Rule Id: {{ selectedDroolsRuleObj.validation_key }} ]
          </label>
}
          <div>{{ selectedDroolsRuleObj?.validation_desc }}</div>
        </div>
      </div>
}

      <!-- Cached Object Panel (only for action_type 'update') -->
      @if (!loading && action_data.action_type === 'update') {
<div class="panel panel-default panel-spaced">
        <div class="panel-heading" (click)="cachedObjOpen = !cachedObjOpen">
          <h4 class="panel-title-inline">Cached Object</h4>
          <span class="pull-right">
            <i class="glyphicon" [ngClass]="cachedObjOpen ? 'glyphicon-chevron-down' : 'glyphicon-chevron-up'"></i>
          </span>
        </div>
        @if (cachedObjOpen) {
<div class="panel-body">
          @if (selectedCachingObjects.length === 0) {
<div class="row">
            <div class="col-md-12 noActions">No Cache Object Defined</div>
          </div>
}
          @if (selectedCachingObjects.length > 0) {
<div>
            <div class="row" style="margin-top: 10px;">
              <div class="col-md-2"><label>Cache Id</label></div>
              <div class="col-md-2" style="text-align: center;"><label>Cache Label</label></div>
              <div class="col-md-2" style="text-align: center;"><label>Enabled</label></div>
              <div class="col-md-2"><label>Order</label></div>
              <div class="col-md-2"><label>Delay Execution</label></div>
              <div class="col-md-2"></div>
            </div>
            @for (cache of selectedCachingObjects; track $index; let i = $index) {
<div class="row" style="margin-top: 10px;">
              <div class="col-md-2">
                <input type="text" class="form-control" [ngModel]="cache.id" [name]="'cache_id_' + i" disabled />
              </div>
              <div class="col-md-2">
                <input type="text" class="form-control" [ngModel]="cache.label" [name]="'cache_label_' + i" disabled />
              </div>
              <div class="col-md-2" style="text-align: center;">
                <input type="checkbox" [(ngModel)]="cache.enabled" [name]="'cache_enabled_' + i" />
              </div>
              <div class="col-md-2">
                <input type="number" class="form-control" [(ngModel)]="cache.refresh_order" [name]="'cache_order_' + i" />
              </div>
              <div class="col-md-2" style="text-align: center;">
                <input type="checkbox" [(ngModel)]="cache.delay_refresh" [name]="'cache_delay_' + i" />
              </div>
              <div class="col-md-2"></div>
            </div>
}
          </div>
}
        </div>
}
      </div>
}

      <!-- Secondary Actions Panel -->
      @if (!loading) {
<div class="panel panel-default panel-spaced">
        <div class="panel-heading" (click)="secondaryActionOpen = !secondaryActionOpen">
          <h4 class="panel-title-inline">Secondary Actions</h4>
          <span class="pull-right">
            <i class="glyphicon" [ngClass]="secondaryActionOpen ? 'glyphicon-chevron-down' : 'glyphicon-chevron-up'"></i>
          </span>
        </div>
        @if (secondaryActionOpen) {
<div class="panel-body">
          <div class="row" style="margin-left: 2px">
            <div class="btn btn-sm btn-success" (click)="addSecondaryAction()">
              More Roles? Click to Add <i class="fa fa-plus-circle"></i>
            </div>
          </div>

          @if (noActions) {
<div class="row noActions">
            <div>No Actions Defined</div>
          </div>
}

          @if (!noActions) {
<div>
            <div class="row sa-header-row hidden-xs hidden-sm" style="margin-top: 10px;">
              <div class="col-md-2"><label>Action Key</label></div>
              <div class="col-md-2" style="text-align: center;"><label>Enabled</label></div>
              <div class="col-md-2"><label>Order</label></div>
              <div class="col-md-2"><label>Pre/Post</label></div>
              <div class="col-md-2"><label>Threshold</label></div>
              <div class="col-md-2"></div>
            </div>

            @for (role of action_data.secondary_actions; track $index; let i = $index) {
<div class="row sa-data-row" style="margin-top: 10px;">
              <div class="col-md-2 col-sm-4 col-xs-6 sa-field">
                <label class="visible-xs visible-sm">Action Key</label>
                <input type="text" class="form-control" [(ngModel)]="role.action_key" [name]="'sa_key_' + i" />
              </div>
              <div class="col-md-2 col-sm-4 col-xs-6 sa-field" style="text-align: center;">
                <label class="visible-xs visible-sm">Enabled</label>
                <input type="checkbox"
                       [ngModel]="role.enabled == 1"
                       (ngModelChange)="role.enabled = $event ? 1 : 0"
                       [name]="'sa_enabled_' + i" />
              </div>
              <div class="col-md-2 col-sm-4 col-xs-6 sa-field">
                <label class="visible-xs visible-sm">Order</label>
                <input type="number" class="form-control" [(ngModel)]="role.execution_order" [name]="'sa_order_' + i" />
              </div>
              <div class="col-md-2 col-sm-4 col-xs-6 sa-field">
                <label class="visible-xs visible-sm">Pre/Post</label>
                <select class="form-control" [(ngModel)]="role.pre_or_post" [name]="'sa_method_' + i">
                  @for (m of methods; track $index) {
<option [value]="m.value">{{ m.name }}</option>
}
                </select>
              </div>
              <div class="col-md-2 col-sm-4 col-xs-6 sa-field">
                <label class="visible-xs visible-sm">Threshold</label>
                <input type="text" class="form-control" [(ngModel)]="role.threshold" [name]="'sa_threshold_' + i" />
              </div>
              <div class="col-md-2 col-sm-4 col-xs-6 sa-field sa-delete-cell">
                <i class="fa fa-minus-circle color-red" style="font-size: 24px; cursor: pointer;"
                   ap-tooltip [appendAfterTarget]="true" tooltipContent="Mark Role for Deletion" direction="top"
                   (click)="deleteSecondaryAction(i)"></i>
              </div>
            </div>
}
          </div>
}
        </div>
}
      </div>
}

      <!-- Proc Params Section (when action_type != 'static') -->
      @if (!loading && action_data.action_type !== 'static') {
<div>
        <div class="row row-spaced">
          <div class="col-md-6">
            <label>Input Parameters:</label>
            <input type="text" class="form-control" name="proc_params_in"
                   placeholder="sso_id:String:null,tax_year:String:2015,quarter:String:4"
                   [(ngModel)]="action_data.proc_params_in" />
          </div>
          <div class="col-md-4">
            <label>ex. In Parameters:</label>
            <select class="form-control" name="exampleIn"
                    (change)="setInPut($any($event.target).value)">
              <option value=""></option>
              @for (ex of exampleInList; track $index) {
<option [value]="ex.name">{{ ex.name }}</option>
}
            </select>
          </div>
        </div>

        <div class="row row-spaced">
          <div class="col-md-6">
            <label>Output Parameters:</label>
            <input type="text" class="form-control" name="proc_params_out"
                   placeholder="resultset:OracleTypes.CURSOR,retval:OracleTypes.VARCHAR,error_out:OracleTypes.VARCHAR"
                   [(ngModel)]="action_data.proc_params_out" />
          </div>
          <div class="col-md-4">
            <label>ex. Out Parameters:</label>
            <select class="form-control" name="exampleOut"
                    (change)="setOutPut($any($event.target).value)">
              <option value=""></option>
              @for (ex of exampleOutList; track $index) {
<option [value]="ex.name">{{ ex.name }}</option>
}
            </select>
          </div>
        </div>

        <div class="row row-spaced">
          <div class="col-md-6">
            <label>Stored Procedure Call:</label>
            <input type="text" class="form-control" name="proc_call"
                   placeholder="begin gtw_test.proc_full_test(?,?,?,?,?,?,?);end;"
                   [(ngModel)]="action_data.proc_call" />
          </div>
          <div class="col-md-4">
            <label>ex. Proc Calls:</label>
            <select class="form-control" name="exampleProc"
                    (change)="setProc($any($event.target).value)">
              <option value=""></option>
              @for (ex of exampleProcList; track $index) {
<option [value]="ex.name">{{ ex.name }}</option>
}
            </select>
          </div>
        </div>
      </div>
}

      <!-- Static Json Section (when action_type === 'static') -->
      @if (!loading && action_data.action_type === 'static') {
<div class="row row-spaced">
        <div class="col-md-8">
          <label class="label-nowrap">Static Json: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Static JSON object returned by this action" direction="top"></i></label>
          <textarea style="min-height: 200px; width: 100%;"
                    [(ngModel)]="action_data.static_values" name="static_values"></textarea>
        </div>
      </div>
}

    </form>
  </div>

  <!-- Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button class="btn btn-info btn-sm" type="button" (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="reset()">Reset Form</button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
